export function buildWhatsappMessageSentNote(message: String) {
  return `Whatsapp inviato tramite gestionale.

L'invio dal client WhatsApp potrebbe non essere stato finalizzato o il testo potrebbe essere stato modificato successivamente.

"${message}"`;
}
